/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type AccessEligibilityStatus =
  (typeof AccessEligibilityStatus)[keyof typeof AccessEligibilityStatus];

export const AccessEligibilityStatus = {
  in_progress: "in_progress",
  completed: "completed",
  failed: "failed",
} as const;
